/* eslint-disable @typescript-eslint/ban-types */
import { Action10061Options } from '@hfzq/crab-utils/esm/utils/navigation/action10061';
import { queryStringifyUrl } from '@hfzq/crab-utils';
import {
  ExtraMapMesg,
  extraNavigate,
  ExtraNavigateOptions,
  ExtraQuery,
  extraReplace,
  generateExtraFullUrl,
} from './navigate';

type QueryType<Q extends ExtraQuery, M extends ExtraMapMesg = {}> = keyof ExcludePartial<Q> extends never
  ? Partial<Pick<ExtraNavigateOptions<Q, M>, 'query'>>
  : Pick<ExtraNavigateOptions<Q, M>, 'query'>;

type MapMesgType<M extends ExtraMapMesg, Q extends ExtraQuery = {}> = keyof ExcludePartial<M> extends never
  ? Partial<Pick<ExtraNavigateOptions<Q, M>, 'mapMesg'>>
  : Pick<ExtraNavigateOptions<Q, M>, 'mapMesg'>;

type PartialNavigateParams<Q extends ExtraQuery, M extends ExtraMapMesg> = keyof ExcludePartial<Q & M> extends never
  ? void | Partial<ExtraNavigateOptions<Q, M>>
  : QueryType<Q> & MapMesgType<M> & Pick<ExtraNavigateOptions<Q, M>, 'webviewConfig'>;

type GetCurrentUrlFuncParams<Q extends ExtraQuery> = keyof Q extends never ? ExtraQuery | void : Q;

/**
 * 生成外部跳转路由对象
 * @param path 跳转地址
 */
export function createExtraRoute<Q extends ExtraQuery = {}, M extends ExtraMapMesg = {}>(
  path: string,
  defaultWebViewConfig?: Action10061Options
) {
  return {
    navigate(options: PartialNavigateParams<Q, M>) {
      extraNavigate(path, {
        ...options,
        webviewConfig: { ...defaultWebViewConfig, ...options?.webviewConfig },
      } as ExtraNavigateOptions<Q, M>);
    },
    replace(options: PartialNavigateParams<Q, M>) {
      extraReplace(path, {
        ...options,
        webviewConfig: { ...defaultWebViewConfig, ...options?.webviewConfig },
      } as ExtraNavigateOptions<Q, M>);
    },
    path,
    getCurrentUrl(query: GetCurrentUrlFuncParams<Q>) {
      return { appOpenPath: queryStringifyUrl(generateExtraFullUrl(path), query || undefined) };
    },
  };
}
